import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import { Subscription }      from 'rxjs/Subscription';

import * as providers from '../../providers/providers';
import * as models    from '../../models/models';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage implements OnInit {
  loggin: boolean = false;
  public loginEmail: string;
  public loginPassword: string;
  public loginError: string;

  logged_in: models.FirebaseUser = null;

  constructor(private router: Router, private db: providers.StamplingDB) {}

  ngOnInit() {
    this.logged_in = this.db.getLoggedUser();
  }

  doLogin(): void {
    this.loggin = true;
    this.loginError=null;
    this.db
        .login(this.loginEmail, this.loginPassword)
        .then((logged) => {
          this.logged_in = logged;
          this.loggin = false;
        })
        .catch((err) => {
          console.log(err);
          this.loggin = false;
        })
  }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/pages/login/login.ts